import { AdhocPortalOrder, PortalOrder } from "../types";

export function isAdhocPortalOrder(order: PortalOrder | AdhocPortalOrder): order is AdhocPortalOrder {
  return order.Role === 'AdHoc'
}
